// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1fTOb","unreadBadge":"styles_unreadBadge__3nukp","modalContent":"styles_modalContent__nMOjk","modal":"styles_modal__33JF5"};